import { cropIcons as icons } from 'img/icons'

const names = {
	VITE: 'vite',
	OLIVO: 'olivo',
	MELO: 'melo',
	AGRUMI: 'agrumi',
	GRANO: 'grano',
}

const crops = [
	{
		id: 2,
		name: names.VITE,
		dssName: 'Vite Sana',
		icon: icons.vite,
		iconHover: icons.vite_over,
	},
	{
		id: 3,
		name: names.OLIVO,
		dssName: 'Olivo Sano',
		icon: icons.olivo,
		iconHover: icons.olivo_over,
	},
	{
		id: 4,
		name: names.MELO,
		dssName: 'Melo Sano',
		icon: icons.melo,
		iconHover: icons.melo_over,
	},
	{
		id: 5,
		name: names.AGRUMI,
		dssName: 'Agrume Sano',
		icon: icons.agrumi,
		iconHover: icons.agrumi_over,
	},
	{
		id: 6,
		name: names.GRANO,
		dssName: 'Grano Sano',
		icon: icons.grano,
		iconHover: icons.grano_over,
	},
]

export function findCropByName(cropName) {
	return crops.find(c => c.name === cropName)
}

const phases = {
	vite: [
		{
			name: 'vite-riposo',
			label: 'riposo',
			picture: require('img/pictures/pheno-vite-riposo.jpg'),
			period: 'Gen-Mar',
		},
		{
			name: 'vite-germoglio',
			label: 'germogliamento',
			picture: require('img/pictures/pheno-vite-germoglio.jpg'),
			period: 'Apr',
		},
		{
			name: 'vite-fioritura-1',
			label: 'inizio fioritura',
			picture: require('img/pictures/pheno-vite-fioritura.jpg'),
			period: 'Mag',
		},
		{
			name: 'vite-fioritura-2',
			label: 'fioritura',
			picture: require('img/pictures/pheno-vite-fioritura.jpg'),
			period: 'Mag',
		},
		{
			name: 'vite-accrescimento',
			label: 'accrescimento germogli e foglie',
			picture: require('img/pictures/pheno-vite-accrescimento.jpg'),
			period: 'Giu',
		},
		{
			name: 'vite-allegagione',
			label: 'allegagione',
			picture: require('img/pictures/pheno-vite-allegagione.jpg'),
			period: 'Giu',
		},
		{
			name: 'vite-invaiatura',
			label: 'invaiatura',
			picture: require('img/pictures/pheno-vite-invaiatura.jpg'),
			period: 'Lug',
		},
		{
			name: 'vite-maturazione',
			label: 'maturazione',
			picture: require('img/pictures/pheno-vite-maturazione.jpg'),
			period: 'Ago',
		},
		{
			name: 'vite-raccolta',
			label: 'raccolta',
			picture: require('img/pictures/pheno-vite-raccolta.jpg'),
			period: 'Set-Ott',
		},
		{
			name: 'vite-defogliazione',
			label: 'defogliazione',
			picture: require('img/pictures/pheno-vite-defogliazione.jpg'),
			period: 'Nov-Dic',
		},
	],
	olivo: [
		{
			name: 'olivo-riposo',
			label: 'riposo',
			picture: require('img/pictures/pheno-olivo-riposo.jpg'),
			period: 'Gen',
		},
		{
			name: 'olivo-emissione',
			label: 'emissione nuovi germogli',
			picture: require('img/pictures/pheno-olivo-emissione.jpg'),
			period: 'Feb',
		},
		{
			name: 'olivo-mignolatura',
			label: 'ripresa vegetativa e mignolatura',
			picture: require('img/pictures/pheno-olivo-mignolatura.jpg'),
			period: 'Mar',
		},
		{
			name: 'olivo-germoglio',
			label: 'germoglio',
			picture: require('img/pictures/pheno-olivo-germoglio.jpg'),
			period: 'Apr',
		},
		{
			name: 'olivo-fioritura-1',
			label: 'inizio fioritura',
			picture: require('img/pictures/pheno-olivo-fioritura-1.jpg'),
			period: 'Mag',
		},
		{
			name: 'olivo-fioritura-2',
			label: 'fioritura',
			picture: require('img/pictures/pheno-olivo-fioritura-2.jpg'),
			period: 'Mag',
		},
		{
			name: 'olivo-allegagione',
			label: 'allegagione',
			picture: require('img/pictures/pheno-olivo-allegagione.jpg'),
			period: 'Giu',
		},
		{
			name: 'olivo-accrescimento-1',
			label: 'accrescimento frutti',
			picture: require('img/pictures/pheno-olivo-accrescimento-1.jpg'),
			period: 'Giu',
		},
		{
			name: 'olivo-indurimento',
			label: 'indurimento nocciolo',
			picture: require('img/pictures/pheno-olivo-indurimento.jpg'),
			period: 'Lug',
		},
		{
			name: 'olivo-accrescimento-2',
			label: 'accrescimento frutto',
			picture: require('img/pictures/pheno-olivo-accrescimento-2.jpg'),
			period: 'Ago',
		},
		{
			name: 'olivo-invaiatura',
			label: 'invaiatura',
			picture: require('img/pictures/pheno-olivo-invaiatura.jpg'),
			period: 'Set',
		},
		{
			name: 'olivo-maturazione-1',
			label: 'maturazione',
			picture: require('img/pictures/pheno-olivo-maturazione-1.jpg'),
			period: 'Ott',
		},
		{
			name: 'olivo-maturazione-2',
			label: 'maturazione',
			picture: require('img/pictures/pheno-olivo-maturazione-2.jpg'),
			period: 'Nov',
		},
		{
			name: 'olivo-defogliazione',
			label: 'defogliazione',
			picture: require('img/pictures/pheno-olivo-defogliazione.jpg'),
			period: 'Dic',
		},
	],
	melo: [
		{
			name: 'melo-dormienza-1',
			label: 'dormienza',
			picture: require('img/pictures/pheno-melo-dormienza.jpg'),
			period: 'Gen',
		},
		{
			name: 'melo-gemme',
			label: 'rigonfiamento gemme',
			picture: require('img/pictures/pheno-melo-gemme.jpg'),
			period: 'Feb',
		},
		{
			name: 'melo-mazzetti',
			label: 'ripresa vegetativa', //'comparsa mazzetti fiorali',
			picture: require('img/pictures/pheno-melo-mazzetti.jpg'),
			period: 'Mar',
		},
		{
			name: 'melo-fioritura-1',
			label: 'inizio fioritura',
			picture: require('img/pictures/pheno-melo-fioritura-1.jpg'),
			period: 'Apr',
		},
		{
			name: 'melo-fioritura-2',
			label: 'piena fioritura',
			picture: require('img/pictures/pheno-melo-fioritura-2.jpg'),
			period: 'Apr-Mag',
		},
		{
			name: 'melo-caduta-petali',
			label: 'caduta petali',
			picture: require('img/pictures/pheno-melo-caduta-petali.jpg'),
			period: 'Mag',
		},
		{
			name: 'melo-allegagione',
			label: 'allegagione',
			picture: require('img/pictures/pheno-melo-allegagione.jpg'),
			period: 'Giu',
		},
		{
			name: 'melo-crescita-pomi',
			label: 'crescita pomi',
			picture: require('img/pictures/pheno-melo-crescita-pomi.jpg'),
			period: 'Lug',
		},
		{
			name: 'melo-maturazione-1',
			label: 'maturazione',
			picture: require('img/pictures/pheno-melo-maturazione-1.jpg'),
			period: 'Ago',
		},
		{
			name: 'melo-maturazione-2',
			label: 'piena maturazione',
			picture: require('img/pictures/pheno-melo-maturazione-2.jpg'),
			period: 'Set',
		},
		{
			name: 'melo-raccolta',
			label: 'raccolta',
			picture: require('img/pictures/pheno-melo-raccolta.jpg'),
			period: 'Set-Ott',
		},
		{
			name: 'melo-defogliazione',
			label: 'defogliazione',
			picture: require('img/pictures/pheno-melo-defogliazione.jpg'),
			period: 'Ott-Nov',
		},
		{
			name: 'melo-dormienza-2',
			label: 'dormienza',
			picture: require('img/pictures/pheno-melo-dormienza.jpg'),
			period: 'Dic',
		},
	],
	agrumi: [
		{
			name: 'agrumi-riposo-1',
			label: 'riposo invernale',
			picture: require('img/pictures/pheno-agrumi-riposo.jpg'),
			period: 'Gen-Feb',
		},
		{
			name: 'agrumi-germogliamento',
			label: 'germogliamento',
			picture: require('img/pictures/pheno-agrumi-germogliamento.jpg'),
			period: 'Mar',
		},
		{
			name: 'agrumi-fioritura',
			label: 'fioritura',
			picture: require('img/pictures/pheno-agrumi-fioritura.jpg'),
			period: 'Apr',
		},
		{
			name: 'agrumi-impollinazione',
			label: 'impollinazione',
			picture: require('img/pictures/pheno-agrumi-impollinazione.jpg'),
			period: 'Mag',
		},
		{
			name: 'agrumi-allegagione',
			label: 'allegagione',
			picture: require('img/pictures/pheno-agrumi-allegagione.jpg'),
			period: 'Giu',
		},
		{
			name: 'agrumi-invaiatura',
			label: 'invaiatura',
			picture: require('img/pictures/pheno-agrumi-invaiatura.jpg'),
			period: 'Lug',
		},
		{
			name: 'agrumi-maturazione',
			label: 'maturazione e raccolta',
			picture: require('img/pictures/pheno-agrumi-maturazione.jpg'),
			period: 'Lug-Ott',
		},
		{
			name: 'agrumi-riposo-2',
			label: 'riposo invernale',
			picture: require('img/pictures/pheno-agrumi-riposo.jpg'),
			period: 'Nov-Dic',
		},
	],
	grano: [
		{
			name: 'grano-germinazione',
			label: 'germinazione',
			picture: require('img/pictures/pheno-grano-germinazione.jpg'),
			period: '20 gg',
		},
		{
			name: 'grano-accestimento-1',
			label: 'inizio accestimento',
			picture: require('img/pictures/pheno-grano-accestimento.jpg'),
			period: '70 gg',
		},
		{
			name: 'grano-accestimento-2',
			label: 'fine accestimento',
			picture: require('img/pictures/pheno-grano-accestimento.jpg'),
			period: '30 gg',
		},
		{
			name: 'grano-levata',
			label: 'levata',
			picture: require('img/pictures/pheno-grano-levata.jpg'),
			period: '30 gg',
		},
		{
			name: 'grano-fioritura',
			label: 'fioritura',
			picture: require('img/pictures/pheno-grano-fioritura.jpg'),
			period: '30 gg',
		},
		{
			name: 'grano-maturazione',
			label: 'maturazione',
			picture: require('img/pictures/pheno-grano-maturazione.jpg'),
			period: '30 gg',
		},
		{
			name: 'grano-senescenza',
			label: 'raccolta / senescenza',
			picture: require('img/pictures/pheno-grano-senescenza.jpg'),
			period: '30 gg',
		},
	],
}

const adversities = {
	vite: [
		{
			name: 'vite-peronospora',
			label: 'Peronospora',
			alertIds: [0, 8, 9, 10],
			picture: require('img/pictures/vite-peronospora.jpg'),
		},
		{
			name: 'vite-oidio',
			label: 'Oidio',
			alertIds: [1, 11, 12],
			picture: require('img/pictures/vite-oidio.jpg'),
		},
		{
			name: 'vite-botrite',
			label: 'Botrite',
			alertIds: [2],
			picture: require('img/pictures/vite-botrite.jpg'),
		},
	],
	olivo: [
		{
			name: 'olivo-cicloconio',
			label: 'Cicloconio o occhio di pavone',
			alertIds: [13],
			picture: require('img/pictures/olivo-cicloconio.jpg'),
			chartPage: '/statistics-olivo-cicloconio',
			susceptibilitySettingName: 'cicloconioSusceptibility',
			susceptibilityParams: [
				{ name: 'cicloconioTemperatureTL', values: { basso: 10, medio: 7, alto: 5 } },
				{ name: 'cicloconioHumidityTL', values: { basso: 95, medio: 90, alto: 80 } },
				{ name: 'cicloconioHumidityHoursTL', values: { basso: 36, medio: 24, alto: 12 } },
				{ name: 'cicloconioLeafHumidityTL', values: { basso: 80, medio: 70, alto: 60 } },
				{ name: 'cicloconioWettingHoursTL', values: { basso: 8, medio: 6, alto: 5 } },
			],
		},
		{
			name: 'olivo-lebbra',
			label: 'Lebbra delle olive',
			alertIds: [14],
			picture: require('img/pictures/olivo-lebbra.jpg'),
		},
		{
			name: 'olivo-rogna',
			label: "Rogna dell'olivo",
			alertIds: [15],
			picture: require('img/pictures/olivo-rogna.jpg'),
		},
	],
	melo: [
		{
			name: 'melo-ticchiolatura',
			label: 'Ticchiolatura',
			alertIds: [16, 17, 18],
			picture: require('img/pictures/melo-ticchiolatura-frutto.jpg'),
			chartPage: '/statistics-melo-ticchiolatura',
		}
	],
	agrumi: [
		{
			name: 'agrumi-oidio',
			label: 'Oidio',
			alertIds: [19, 20],
			picture: require('img/pictures/agrumi-oidio-2.jpg'),
		},
	],
	grano: [
		{
			name: 'grano-septoria',
			label: 'Septoria',
			alertIds: [21, 22],
			picture: require('img/pictures/grano-septoria-1.jpg'),
			susceptibilitySettingName: 'septoriaSusceptibility',
			susceptibilityParams: [
				{ name: 'septoriaTemperatureThLow', values: { basso: 12, medio: 9, alto: 6 } },
				{ name: 'septoriaTemperatureThHigh', values: { basso: 25, medio: 28, alto: 30 } },
				{ name: 'septoriaHumidityThLow', values: { basso: 80, medio: 70, alto: 60 } },
				{ name: 'septoriaWettingHoursThLow', values: { basso: 6, medio: 4, alto: 3 } },
			],
		},
		{
			name: 'grano-oidio',
			label: 'Oidio',
			alertIds: [23],
			picture: require('img/pictures/grano-oidio.jpg'),
			susceptibilitySettingName: 'oidioGranoSusceptibility',
			susceptibilityParams: [
				{ name: 'oidioGranoTemperatureThLow', values: { basso: 10, medio: 7, alto: 4 } },
				{ name: 'oidioGranoTemperatureThHigh', values: { basso: 24, medio: 27, alto: 30 } },
				{ name: 'oidioGranoHumidityThLow', values: { basso: 90, medio: 80, alto: 70 } },
				{ name: 'oidioGranoWettingHoursThLow', values: { basso: 8, medio: 6, alto: 4 } },
			],
		},
		{
			name: 'grano-ruggine-bruna',
			label: 'Ruggine bruna',
			alertIds: [24],
			picture: require('img/pictures/grano-ruggine-bruna.jpg'),
			susceptibilitySettingName: 'ruggineBrunaSusceptibility',
			susceptibilityParams: [
				{ name: 'ruggineBrunaTemperatureThLow', values: { basso: 10, medio: 9, alto: 5 } },
				{ name: 'ruggineBrunaTemperatureThHigh', values: { basso: 20, medio: 23, alto: 26 } },
				{ name: 'ruggineBrunaHumidityThLow', values: { basso: 90, medio: 80, alto: 70 } },
				{ name: 'ruggineBrunaWettingHoursThLow', values: { basso: 10, medio: 8, alto: 6 } },
			],
		},
		{
			name: 'grano-ruggine-gialla',
			label: 'Ruggine gialla',
			alertIds: [25],
			picture: require('img/pictures/grano-ruggine-gialla.jpg'),
			susceptibilitySettingName: 'ruggineGiallaSusceptibility',
			susceptibilityParams: [
				{ name: 'ruggineGiallaTemperatureThLow', values: { basso: 12, medio: 10, alto: 6 } },
				{ name: 'ruggineGiallaTemperatureThHigh', values: { basso: 18, medio: 20, alto: 24 } },
				{ name: 'ruggineGiallaHumidityThLow', values: { basso: 90, medio: 80, alto: 70 } },
				{ name: 'ruggineGiallaWettingHoursThLow', values: { basso: 6, medio: 4, alto: 3 } },
			],
		},
	],
}

const Crops = { crops, phases, adversities }
export default Crops
